import { render, staticRenderFns } from "./MainTheme.vue?vue&type=template&id=d43e495c&"
import script from "./MainTheme.vue?vue&type=script&lang=js&"
export * from "./MainTheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContent } from 'vuetify/lib'
installComponents(component, {
  VContent,
})
